export default __webpack_public_path__ + "static/media/chev-right-pink-btn.0ab5eec2.svg";